import React,{useState,useEffect,useRef} from 'react'
import '../styles/settings.css'
import {Select,Input,Button,InputErrorMassage,BigInput} from '../comps/comps'
import {useSelector,useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom';
import * as actions from '../store/authAction'
import * as action from '../store/actions'
import {Helmet} from "react-helmet";
import * as authAction from '../store/authAction'
import Headerphoto from '../comps/headerphoto'
import {FiUser, FiLock, FiGlobe, FiCamera, FiLogOut, FiX} from 'react-icons/fi'
import { COUNTRIES } from '../utils/countries'
import { hobbySuggestions, parseHobbies, joinHobbies, ageFromBirthday } from '../utils/hobbies'
import { uploadPostFile } from '../utils/postImages'
import SettingsCalendar from '../comps/settingsCalendar'

const mediaSrc = file => {
  if (!file) return ''
  if (typeof file === 'object') return URL.createObjectURL(file)
  return `/api/uploads/${file}`
}

const fileName = file => (file && typeof file === 'object' ? file.name : file) || ''
const birthdayKey = id => `pinweelo-bday-${String(id || '')}`

const LANGUAGES = [
  {code: 'en', label: 'English'},
  {code: 'ru', label: 'Russian'},
  {code: 'fr', label: 'French'},
  {code: 'sp', label: 'Spanish'},
  {code: 'ar', label: 'Arabic'},
  {code: 'de', label: 'German'},
  {code: 'it', label: 'Italian'},
  {code: 'pt', label: 'Portuguese'},
  {code: 'zh', label: 'Chinese'},
  {code: 'ja', label: 'Japanese'},
  {code: 'ko', label: 'Korean'},
  {code: 'hi', label: 'Hindi'},
  {code: 'tr', label: 'Turkish'},
  {code: 'nl', label: 'Dutch'},
  {code: 'he', label: 'Hebrew'},
  {code: 'pl', label: 'Polish'},
  {code: 'sv', label: 'Swedish'},
  {code: 'uk', label: 'Ukrainian'},
  {code: 'id', label: 'Indonesian'},
  {code: 'th', label: 'Thai'}
]

const Settings = props => {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  useEffect(async()=>{
    const userData = localStorage.getItem('userdata');
    if(userData){
      const {id,pid} = await JSON.parse(userData);
      await dispatch(authAction.auth(id,pid));


    }else{
   navigate('../auth');
    }

  },[dispatch])

const userlist = useSelector(state => state.authReduse) || {};
const translations = useSelector(state => state.lang_reduse.lang || {});
const lang = useSelector(state => state.lang_reduse.code || 'en');
const [email,setEmail] = useState(userlist.email || '');
const [postion,setPostion] = useState(userlist.postion || '');
const [age,setAge] = useState(userlist.age || '');
const [hobbies,setHobbies] = useState(() => parseHobbies(userlist.hobby));
const [hobbyQuery,setHobbyQuery] = useState('');
const [hobbyOpen,setHobbyOpen] = useState(false);
const hobbyInputRef = useRef(null);
const [birthday,setBirthday] = useState('');
const [job,setJob] = useState(userlist.job || '');
const [photo,setPhoto] = useState(userlist.photo || '');
const [cardid,setCardId] = useState('cardid');
const [bio,setBio] = useState(userlist.bio || '');
const [name,setName] = useState(userlist.name || '');
const [password,setPassword] = useState('');
const [saveError,setSaveError] = useState('');
const [saving,setSaving] = useState(false);

useEffect(() => {
  if (!userlist.id) return
  setEmail(current => current || userlist.email || '')
  setPostion(current => current || userlist.postion || '')
  setAge(current => current || userlist.age || '')
  setHobbies(current => current.length ? current : parseHobbies(userlist.hobby))
  setJob(current => current || userlist.job || '')
  setPhoto(current => current || userlist.photo || '')
  setBio(current => current || userlist.bio || '')
  setName(current => current || userlist.name || '')
  try {
    const saved = localStorage.getItem(birthdayKey(userlist.id))
    if (saved) {
      setBirthday(current => current || saved)
      setAge(current => current || ageFromBirthday(saved) || userlist.age || '')
    }
  } catch (err) {}
}, [userlist.id, userlist.age])

const updateHandel = async () =>{
  const nextEmail = String(email || '').trim()
  const nextName = String(name || '').trim()
  const nextPassword = String(password || '')
  if (nextEmail.length < 5 || nextEmail.length > 80) {
    setSaveError('Email should be 5 to 80 characters')
    return
  }
  if (nextName.length < 3 || nextName.length > 30) {
    setSaveError('Name should be 3 to 30 characters')
    return
  }
  if (nextPassword && nextPassword.length !== 10) {
    setSaveError('Password must be 10 characters, or leave it blank')
    return
  }
  setSaveError('')
  setSaving(true)
  try {
    let img = fileName(photo)
    if (typeof photo === 'object' && photo) {
      img = await uploadPostFile(photo, 0)
    }
    const years = Number(age) || ageFromBirthday(birthday) || 0
    await dispatch(actions.update(nextEmail,postion,job,joinHobbies(hobbies),img,userlist.big_img,nextName,nextPassword,userlist.story,bio,years))
    try {
      if (userlist.id && birthday) localStorage.setItem(birthdayKey(userlist.id), birthday)
    } catch (err) {}
  } catch (err) {
    setSaveError(err.message || 'Could not save settings')
  } finally {
    setSaving(false)
  }
}

const logOutHandel = () =>{
  dispatch(actions.log_out())
  navigate('/auth')
}

const changeLangHandeler = e =>{
  dispatch(action.changelang(e.target.value))
}

return(
  <section className="Settings">
    <Helmet>
    <title>pinweelo Settings</title>
       <meta name="theme-color" content="#08090d" />
  <meta name="description" content='help center you can edit you profile info and your location'/>
<meta name='keywords' content='settings,change,settings page'/>
 <link rel="canonical" href="https://pinweelo.com/settings" />
    </Helmet>
    <Headerphoto showBack hidePhoto title={translations.settings || 'Settings'}/>
    <div className="settingsShell">
      <header className="settingsHero">
        <label className="settingsHeroPhoto">
          <span className="settingsAvatarWell">
            {mediaSrc(photo) ? <img src={mediaSrc(photo)} alt="" className="fullImg" /> : <span className="settingsPickerIcon"><FiUser /></span>}
            <span className="settingsAvatarBadge"><FiCamera /></span>
          </span>
          <span className="settingsHeroPhotoHint">{photo ? translations.changePhoto : translations.addPhoto}</span>
          <input className="Inputfile" type="file" accept="image/*" onChange={e => setPhoto(e.target.files[0])} />
        </label>
      </header>

      <div className="settingsCard">
        <h2><FiUser /> {translations.profile}</h2>
        <label className="settingsField"><span>{translations.displayName}</span><Input placeholder={translations.displayName} value={name} onChange={e=> setName(e.target.value)} />
        {name ? <InputErrorMassage text='name should be 3 to 30' val={String(name || '')} num={[3,30]} /> : null}</label>
        <label className="settingsField"><span>{translations.email}</span><Input placeholder={translations.email} value={email} onChange={e=> setEmail(e.target.value)} />
        {email ? <InputErrorMassage text='email should be 5 to 80' val={String(email || '')} num={[5,80]} /> : null}</label>
        <div className="settingsGrid">
          <div className="settingsField"><span>{translations.birthday}</span>
            <SettingsCalendar
              value={birthday}
              placeholder={translations.pickBirthday}
              onChange={next => {
                setBirthday(next)
                setAge(ageFromBirthday(next))
              }}
            />
          </div>
          <label className="settingsField"><span>{translations.job}</span><Input placeholder={translations.job} value={job} onChange={e=> setJob(e.target.value)} />
          {job ? <InputErrorMassage text='job should be 2 to 40' val={String(job || '')} num={[2,40]} /> : null}</label>
        </div>
        <div className="settingsField"><span>{translations.hobby}</span>
          <div
            className="settingsHobbyBox"
            onClick={() => {
              setHobbyOpen(true)
              window.setTimeout(() => hobbyInputRef.current && hobbyInputRef.current.focus(), 0)
            }}
          >
            {hobbies.map(item => (
              <span key={item} className="settingsHobbyChip">
                {item}
                <button type="button" aria-label={`Remove ${item}`} onClick={event => {
                  event.stopPropagation()
                  setHobbies(list => list.filter(hobby => hobby !== item))
                }}>
                  <FiX />
                </button>
              </span>
            ))}
            {hobbyOpen ? (
              <div className="settingsSuggest settingsHobbySearch">
                <input
                  ref={hobbyInputRef}
                  className="settingsHobbyInput"
                  placeholder={hobbies.length ? 'Add another' : 'Search hobbies'}
                  value={hobbyQuery}
                  onChange={event => { setHobbyQuery(event.target.value); setHobbyOpen(true) }}
                  onBlur={() => window.setTimeout(() => { setHobbyOpen(false); setHobbyQuery('') }, 140)}
                  onKeyDown={event => {
                    if (event.key !== 'Enter') return
                    event.preventDefault()
                    const next = hobbyQuery.trim()
                    if (next.length < 2 || hobbies.some(item => item.toLowerCase() === next.toLowerCase())) return
                    setHobbies(list => [...list, next].slice(0, 8))
                    setHobbyQuery('')
                  }}
                />
                {hobbySuggestions(hobbyQuery, hobbies).length > 0 ? (
                  <ul className="settingsSuggestList">
                    {hobbySuggestions(hobbyQuery, hobbies).map(item => (
                      <li key={item}>
                        <button
                          type="button"
                          onMouseDown={event => {
                            event.preventDefault()
                            setHobbies(list => list.includes(item) ? list : [...list, item].slice(0, 8))
                            setHobbyQuery('')
                          }}
                        >
                          {item}
                        </button>
                      </li>
                    ))}
                  </ul>
                ) : null}
              </div>
            ) : (
              <span className="settingsHobbyPlaceholder">{hobbies.length ? 'Add another' : 'Search hobbies'}</span>
            )}
          </div>
        </div>
        <label className="settingsField"><span>{translations.bio}</span><BigInput height="110px" placeholder={translations.bio} value={bio} onChange={e=> setBio(e.target.value)} />
        {bio ? <InputErrorMassage text='bio should be 3 to 200' val={String(bio || '')} num={[3,200]} /> : null}</label>
      </div>

      <div className="settingsCard">
        <h2><FiGlobe /> {translations.preferences}</h2>
          <label className="settingsField"><span>{translations.language}</span>
            <select className="Select" value={lang} onChange={changeLangHandeler}>
              {LANGUAGES.map(item => <option key={item.code} value={item.code}>{item.label}</option>)}
            </select>
          </label>
        <label className="settingsField"><span>{translations.country}</span><Select list={['Select country', ...COUNTRIES]} value={postion} autoComplete="off" onChange={e=> setPostion(e.target.value)} /></label>
        <label className="settingsField"><span>{translations.cardId}</span><Input placeholder={translations.cardId} value={cardid} onChange={e=> setCardId(e.target.value)} /></label>
      </div>

      <div className="settingsCard">
        <h2><FiLock /> {translations.security}</h2>
        <label className="settingsField"><span>{translations.password}</span><Input placeholder="Leave blank to keep current" value={password} onChange={e => setPassword(e.target.value)} />
        {password ? <InputErrorMassage text='password should be 10' val={String(password || '')} num={[10,10]} /> : null}</label>
      </div>

      <div className="settingsActions">
        {['bily-wilk', 'billy-wilk'].includes(String(userlist.id || '').toLowerCase()) ? (
          <button type="button" className="settingsLogout" onClick={() => navigate('/admin')}>Control</button>
        ) : null}
        <button type="button" className="settingsLogout" onClick={() => navigate('/ben')}>Ben</button>
        <Button title={saving ? 'Saving…' : translations.saveChanges} click={updateHandel} />
        {saveError ? <p className="settingsHint" style={{color:'#ff8f8f'}}>{saveError}</p> : null}
        <button type="button" className="settingsLogout" onClick={logOutHandel}>
          <FiLogOut /> {translations.logout}
        </button>
      </div>
    </div>
  </section>
  )
}
export default Settings;
